import { getEventsView as publicGetEventsView } from './calendar-v3-events-view-event-views.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onEventsViewExtended as publicOnEventsViewExtended } from './calendar-v3-events-view-event-views.public.js';
import { onEventsViewProjectionUpdated as publicOnEventsViewProjectionUpdated } from './calendar-v3-events-view-event-views.public.js';

export const getEventsView: MaybeContext<
  BuildRESTFunction<typeof publicGetEventsView> & typeof publicGetEventsView
> = /*#__PURE__*/ createRESTModule(publicGetEventsView);
/**
 * Triggered when the current event view is extended.
 *
 *
 * Doesn’t include details about existing events added to the view due to the
 * extension. To receive updates about those events, subscribe to
 * [Events View Projection Updated](https://dev.wix.com/docs/rest/business-management/calendar/event-views-v3/events-view-projection-updated).
 *
 * The event view is periodically extended by Wix Calendars, you can't manually
 * extend it.
 */
export const onEventsViewExtended: BuildEventDefinition<
  typeof publicOnEventsViewExtended
> &
  typeof publicOnEventsViewExtended = createEventModule(
  publicOnEventsViewExtended
);
/**
 * Triggered when an [event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction)
 * is added to, removed from, or updated within the current event view. This includes cases when:
 * + A new event is created within the view.
 * + An existing event within the view is updated, including when it's rescheduled to start outside the view.
 * + An event within the view is deleted.
 * + An event previously outside the view is rescheduled to fall within it.
 * + The view is extended, bringing an existing event into scope.
 */
export const onEventsViewProjectionUpdated: BuildEventDefinition<
  typeof publicOnEventsViewProjectionUpdated
> &
  typeof publicOnEventsViewProjectionUpdated = createEventModule(
  publicOnEventsViewProjectionUpdated
);

export {
  Status,
  RecurrenceType,
  Frequency,
  Day,
  Transparency,
  LocationType,
  Role,
  ParticipantsStatus,
  ProviderType,
  Type,
  Field,
  IdentityType,
  WebhookIdentityType,
} from './calendar-v3-events-view-event-views.universal.js';
export {
  EventsView,
  EventsViewProjectionUpdated,
  EventsViewProjectionUpdatedTypeOneOf,
  EventAddedOrUpdated,
  Event,
  ZonedDate,
  RecurrenceRule,
  Location,
  Resource,
  Participants,
  Participant,
  ConferencingDetails,
  OnlineMeetingInfo,
  Provider,
  ProviderProviderInfoOneOf,
  Permission,
  CommonIdentificationData,
  CommonIdentificationDataIdOneOf,
  ExtendedFields,
  EventRemoved,
  EventsViewExtended,
  GetEventsViewRequest,
  GetEventsViewResponse,
  ExtendEventsViewRequest,
  ExtendEventsViewResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  EventsViewExtendedEnvelope,
  EventsViewProjectionUpdatedEnvelope,
} from './calendar-v3-events-view-event-views.universal.js';
export {
  StatusWithLiterals,
  RecurrenceTypeWithLiterals,
  FrequencyWithLiterals,
  DayWithLiterals,
  TransparencyWithLiterals,
  LocationTypeWithLiterals,
  RoleWithLiterals,
  ParticipantsStatusWithLiterals,
  ProviderTypeWithLiterals,
  TypeWithLiterals,
  FieldWithLiterals,
  IdentityTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './calendar-v3-events-view-event-views.universal.js';
